<template>
  <!-- 河川予警報情報カード -->
  <v-card class="com-mb-card rw-info">
    <v-col class="com-mb-card-contents-none-border pa-0">
      <v-btn
        v-if="
          this.selectedRwDetailMt.inundation &&
            this.selectedRwDetailMt.inundation.inundationId
        "
        class="mr-2"
        :class="{ 'white--text': isDisp, 'success--text': !isDisp }"
        :outlined="!isDisp"
        small
        color="success"
        @click="isDisp = !isDisp"
        ><span>{{ text.dispIu }}</span></v-btn
      >
      <v-btn
        class="mr-2"
        v-if="
          selectedRwDetailRwFlg &&
            selectedWarnType === 10 &&
            selectedRwDetailRw.attchFlg === 1
        "
        outlined
        small
        color="success"
        @click="
          openPdf(
            selectedRwDetailMt.fldfrCd,
            'fldfr',
            selectedRwDetailRw.annNo,
            selectedRwDetailRw.annTime,
            selectedRwDetailRw.docType,
            selectedRwDetailRw.fldfrId
          )
        "
      >
        <span>洪水予報の本文</span>
      </v-btn>
      <v-btn
        class="mr-2"
        v-if="
          selectedRwDetailRwFlg &&
            selectedWarnType === 11 &&
            selectedRwDetailRw.attchFlg === 1
        "
        outlined
        small
        color="success"
        @click="
          openPdf(
            selectedRwDetailMt.evstgCd,
            'evstg',
            selectedRwDetailRw.annNo,
            selectedRwDetailRw.annTime,
            selectedRwDetailRw.docType,
            selectedRwDetailRw.evstgId
          )
        "
      >
        <span>水位到達情報の本文</span>
      </v-btn>
      <v-btn
        class="mr-2"
        v-if="
          selectedRwDetailRwFlg &&
            selectedWarnType === 20 &&
            selectedRwDetailRw.attchFlg === 1
        "
        outlined
        small
        color="success"
        @click="
          openPdf(
            selectedRwDetailMt.fldctlCd,
            'fldctl',
            selectedRwDetailRw.annNo,
            selectedRwDetailRw.annTime,
            selectedRwDetailRw.docType,
            selectedRwDetailRw.fldctlId
          )
        "
      >
        <span>水防警報の本文</span>
      </v-btn>
      <v-btn
        class="mr-2"
        v-if="
          selectedRwDetailRwFlg &&
            selectedWarnType === 30 &&
            selectedRwDetailRw.attchFlg === 1
        "
        outlined
        small
        color="success"
        @click="
          openPdf(
            selectedRwDetailMt.damdschCd,
            'damdsch',
            selectedRwDetailRw.annNo,
            selectedRwDetailRw.annTime,
            selectedRwDetailRw.docType,
            selectedRwDetailRw.damdschId
          )
        "
      >
        <span>ダム放流通知文等の本文</span>
      </v-btn>
    </v-col>

    <v-col class="rw-box-info">
      <!-- 見出し -->
      <v-col
        v-if="
          selectedRwDetailRwFlg &&
            (selectedWarnType === 10 ||
              selectedWarnType === 11 ||
              selectedWarnType === 20)
        "
        class="rw-info-header pl-4 py-2"
      >
        <div>
          {{ selectedRwDetailRw.heading }}
        </div>
      </v-col>
      <!-- ダム放流通知は見出しの部分に観測所名を表示 -->
      <div v-if="selectedWarnType === 30" class="rw-dam-header pl-0 py-2">
        <div class="rw-box-dam-name px-2 ">
          <div class="rw-obs-name-kana">
            {{ selectedRwDetailMt.obsKana }}
          </div>
          <div class="rw-obs-name">
            {{ selectedRwDetailMt.obsNm }}
          </div>
        </div>
        <v-btn
          class="ml-2"
          color="success"
          outlined
          small
          @click="
            clickObs(
              selectedRwDetailMt.ofcCd,
              selectedRwDetailMt.itmkndCd,
              selectedRwDetailMt.obsCd
            )
          "
          >{{ text.btnToDamobs }}</v-btn
        >
      </div>
      <!-- 水系名 区間名 -->
      <v-row v-if="selectedRwDetailMt" class="ma-0">
        <v-col class="pl-8 py-1">
          <div class="name_kana">
            <span>{{ selectedRwDetailMt.rsysKana }}</span>
          </div>
          <div class="name">
            <span>{{ selectedRwDetailMt.rsysNm }}水系</span>
          </div>
        </v-col>
        <v-col class="pl-8 py-1">
          <div class="name_kana">
            <span v-if="selectedWarnType === 10">{{
              selectedRwDetailMt.fldfrKana
            }}</span>
            <span v-if="selectedWarnType === 11">{{
              selectedRwDetailMt.evstgKana
            }}</span>
            <span v-if="selectedWarnType === 20">{{
              selectedRwDetailMt.fldctlKana
            }}</span>
            <span v-if="selectedWarnType === 30">{{
              selectedRwDetailMt.rvrKana
            }}</span>
          </div>
          <div class="name">
            <span v-if="selectedWarnType === 10">{{
              selectedRwDetailMt.fldfrNm
            }}</span>
            <span v-if="selectedWarnType === 11">{{
              selectedRwDetailMt.evstgNm
            }}</span>
            <span v-if="selectedWarnType === 20">{{
              selectedRwDetailMt.fldctlNm
            }}</span>
            <span v-if="selectedWarnType === 30">{{
              selectedRwDetailMt.rvrNm
            }}</span>
          </div>
        </v-col>
      </v-row>
      <!-- 発表状況 -->
      <v-col class="pt-0 pb-2">
        <v-card>
          <div class="rw-state-header">
            発表状況&nbsp;
            <!-- 凡例 -->
            <v-tooltip
              v-if="
                (selectedWarnType === 30 &&
                  config.messageConfig.legendMsg.damdsch.damdschJudge) ||
                  (selectedWarnType === 20 &&
                    config.messageConfig.legendMsg.fldctl.fldctlJudge)
              "
              bottom
              max-width="350"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="dimgray" class="ml-1"
                  >help_outline</v-icon
                >
              </template>
              <!-- <span v-if="selectedWarnType === 10 || selectedWarnType === 11">
                <span>
                  {{ config.messageConfig.legendMsg.fldfr.fldfrMsg1 }}
                  <br />
                  {{ config.messageConfig.legendMsg.fldfr.fldfrMsg2 }}
                  <br />
                </span>
                <img
                  class="rw-legend-img"
                  :src="config.messageConfig.legendMsg.fldfr.img"
                />
              </span> -->
              <span v-if="selectedWarnType === 30">
                {{ config.messageConfig.legendMsg.damdsch.damdschMsg1 }}
                <br />
                <span class="text-damdsch-disasteroperating rw-span-warn mb-1">
                  {{
                    config.messageConfig.legendMsg.damdsch.disasteroperating
                  }}</span
                >
                <br />
                <span class="text-damdsch-riserving rw-span-warn">
                  {{ config.messageConfig.legendMsg.damdsch.riserving }}
                </span>
              </span>
              <span v-if="selectedWarnType === 20">
                {{ config.messageConfig.legendMsg.fldctl.fldctlMsg1 }}
                <br />
                {{ config.messageConfig.legendMsg.fldctl.fldctlMsg2 }}
                <br />
                <span class="text-fldctl-dispatch rw-span-warn mb-1">
                  {{ config.messageConfig.legendMsg.fldctl.dispatch }}
                </span>
                <br />
                <span class="text-fldctl-preparation rw-span-warn mb-1">
                  {{ config.messageConfig.legendMsg.fldctl.preparation }}
                </span>
                <br />
                <span class="text-fldctl-standby rw-span-warn">
                  {{ config.messageConfig.legendMsg.fldctl.standby }}
                </span>
              </span>
            </v-tooltip>
          </div>
          <!-- 洪水予報 -->
          <div
            v-if="selectedRwDetailRwFlg && selectedWarnType === 10"
            class="rw-state-value "
            :class="{
              'text-flood-occurrence': selectedRwDetailRw.fldfrLvl === 90,
              'text-flood-danger': selectedRwDetailRw.fldfrLvl === 80,
              'text-flood-refuge': selectedRwDetailRw.fldfrLvl === 60,
              'text-flood-warn': selectedRwDetailRw.fldfrLvl === 30,
              'text-flood-normal': selectedRwDetailRw.fldfrLvl === 0,
            }"
          >
            <v-row class="rw-state-row ma-0">
              <!-- 前ボタンを非表示 -->
              <!-- <div class="rw-state-prev pl-1">
                <v-btn
                  v-if="isDispPrev"
                  depressed
                  fab
                  x-small
                  @click="prevAnnIdx"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </div> -->
              <div class="rw-state-text">
                <div>
                  第{{ selectedRwDetailRw.annNo }}号&nbsp;
                  {{ selectedRwDetailRw.fldfrKndNmS }}&nbsp;
                  <span v-if="selectedRwDetailRw.fldfrLvl === 30">
                    {{ config.messageConfig.alertLvl.fldfrLvl2 }}&nbsp;
                  </span>
                  <span v-if="selectedRwDetailRw.fldfrLvl === 60">
                    {{ config.messageConfig.alertLvl.fldfrLvl3 }}&nbsp;
                  </span>
                  <span v-if="selectedRwDetailRw.fldfrLvl === 80">
                    {{ config.messageConfig.alertLvl.fldfrLvl4 }}&nbsp;
                  </span>
                  <span v-if="selectedRwDetailRw.fldfrLvl === 90">
                    {{ config.messageConfig.alertLvl.fldfrLvl5 }}&nbsp;
                  </span>
                </div>
                <div>
                  {{ selectedRwDetailRw.annTime }}
                </div>
              </div>
              <!-- 次へボタンを非表示 -->
              <!-- <div class="rw-state-next mr-1">
                <v-btn
                  v-if="isDispNext"
                  depressed
                  fab
                  x-small
                  @click="nextAnnIdx"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </div> -->
            </v-row>
          </div>
          <!-- 未発表メッセージ -->
          <div
            v-if="!selectedRwDetailRwFlg && selectedWarnType === 10"
            class="rw-state-value text-flood-normal"
          >
            {{ text.fldfrAnnounce }}
          </div>
          <!-- 水位周知河川 -->
          <div
            v-if="selectedRwDetailRwFlg && selectedWarnType === 11"
            class="rw-state-value "
            :class="{
              'text-flood-occurrence': selectedRwDetailRw.evstgLvl === 90,
              'text-flood-danger': selectedRwDetailRw.evstgLvl === 80,
              'text-flood-refuge': selectedRwDetailRw.evstgLvl === 60,
              'text-flood-warn': selectedRwDetailRw.evstgLvl === 30,
              'text-flood-normal': selectedRwDetailRw.evstgLvl === 0,
            }"
          >
            <v-row class="rw-state-row ma-0">
              <!-- <div class="rw-state-prev pl-1">
                <v-btn
                  v-if="isDispPrev"
                  depressed
                  fab
                  x-small
                  @click="prevAnnIdx"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </div> -->
              <div class="rw-state-text">
                <div>
                  第{{ selectedRwDetailRw.annNo }}号&nbsp;
                  {{ selectedRwDetailRw.evstgKndNmS }}&nbsp;
                  <span v-if="selectedRwDetailRw.evstgLvl === 30">
                    {{ config.messageConfig.alertLvl.fldfrLvl2 }}&nbsp;
                  </span>
                  <span v-if="selectedRwDetailRw.evstgLvl === 60">
                    {{ config.messageConfig.alertLvl.fldfrLvl3 }}&nbsp;
                  </span>
                  <span v-if="selectedRwDetailRw.evstgLvl === 80">
                    {{ config.messageConfig.alertLvl.fldfrLvl4 }}&nbsp;
                  </span>
                  <span v-if="selectedRwDetailRw.evstgLvl === 90">
                    {{ config.messageConfig.alertLvl.fldfrLvl5 }}&nbsp;
                  </span>
                </div>
                <div>
                  {{ selectedRwDetailRw.annTime }}
                </div>
              </div>
              <!-- <div class="rw-state-next mr-1">
                <v-btn
                  v-if="isDispNext"
                  depressed
                  fab
                  x-small
                  @click="nextAnnIdx"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </div> -->
            </v-row>
          </div>
          <!-- 未発表メッセージ -->
          <div
            v-if="!selectedRwDetailRwFlg && selectedWarnType === 11"
            class="rw-state-value text-flood-normal"
          >
            {{ text.evstgAnnounce }}
          </div>
          <!-- 水防警報 -->
          <div
            v-if="selectedRwDetailRwFlg && selectedWarnType === 20"
            class="rw-state-value "
            :class="{
              'text-fldctl-normal': selectedRwDetailRw.fldctlLvl === 0,
              'text-fldctl-standby': selectedRwDetailRw.fldctlLvl === 10,
              'text-fldctl-preparation': selectedRwDetailRw.fldctlLvl === 20,
              'text-fldctl-dispatch': selectedRwDetailRw.fldctlLvl === 40,
            }"
          >
            <v-row class="rw-state-row ma-0">
              <!-- <div class="rw-state-prev pl-1">
                <v-btn
                  v-if="isDispPrev"
                  depressed
                  fab
                  x-small
                  @click="prevAnnIdx"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </div> -->
              <div class="rw-state-text">
                <div>
                  第{{ selectedRwDetailRw.annNo }}号&nbsp;
                  {{ selectedRwDetailRw.fldctlKndNm }}&nbsp;
                </div>
                <div>
                  {{ selectedRwDetailRw.annTime }}
                </div>
              </div>
              <!-- <div class="rw-state-next mr-1">
                <v-btn
                  v-if="isDispNext"
                  depressed
                  fab
                  x-small
                  @click="nextAnnIdx"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </div> -->
            </v-row>
          </div>
          <!-- 未発表メッセージ -->
          <div
            v-if="!selectedRwDetailRwFlg && selectedWarnType === 20"
            class="rw-state-value text-flood-normal"
          >
            {{ text.fldctlAnnounce }}
          </div>
          <!-- ダム放流通知 -->
          <div
            v-if="selectedRwDetailRwFlg && selectedWarnType === 30"
            class="rw-state-value"
            :class="{
              'text-damdsch-normal': selectedRwDetailRw.damdschLvl === 0,
              'text-damdsch-riserving': selectedRwDetailRw.damdschLvl === 50,
              'text-damdsch-disasteroperating':
                selectedRwDetailRw.damdschLvl === 70,
            }"
          >
            <v-row class="rw-state-row ma-0">
              <!-- <div class="rw-state-prev pl-1">
                <v-btn
                  v-if="isDispPrev"
                  depressed
                  fab
                  x-small
                  @click="prevAnnIdx"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </div> -->
              <div class="rw-state-text">
                <div>
                  第{{ selectedRwDetailRw.annNo }}号
                  {{ selectedRwDetailRw.damdschKndNm }}
                </div>
                <div>
                  {{ selectedRwDetailRw.annTime }}
                </div>
              </div>
              <!-- <div class="rw-state-next mr-1">
                <v-btn
                  v-if="isDispNext"
                  depressed
                  fab
                  x-small
                  @click="nextAnnIdx"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </div> -->
            </v-row>
          </div>
          <!-- 未発表メッセージ -->
          <div
            v-if="!selectedRwDetailRwFlg && selectedWarnType === 30"
            class="rw-state-value text-flood-normal"
          >
            {{ text.damdschAnnounce }}
          </div>
          <!-- <div
            v-if="this.$store.state.RiverWarn.selectedAnnIdx !== 0"
            class="rw-state-footer"
          >
            <v-spacer></v-spacer>
            <span class="rw-state-header-state pr-2">{{ annState }}</span>
          </div> -->
        </v-card>
      </v-col>
    </v-col>
  </v-card>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "rw-info",
  mixins: [mixin],
  data() {
    return {
      isDisp: false,
      text: {
        fldfrAnnounce: "洪水予報は発表されていません",
        evstgAnnounce: "水位到達情報は発表されていません",
        damdschAnnounce: "ダム放流通知は発表されていません",
        fldctlAnnounce: "水防警報は発表されていません",
        btnToDamobs: "ダムを表示",
        dispIu: "浸水想定を確認",
      },
    };
  },
  mounted() {
    // 選択中浸水想定区域データがストアに設定済みであればプルダウンを更新
    if (
      this.$store.state.inundation.selectedInundationParam &&
      this.$store.state.inundation.selectedInundationParam.inundationId
    ) {
      this.selectedInundation = this.$store.state.inundation.selectedInundationParam;
      this.isDisp = true;
    }
  },
  beforeDestroy() {
    this.$store.commit("map/setSelectPointRiver", []);
  },
  computed: {
    /** 最新・過去表示 */
    annState: {
      get() {
        if (this.$store.state.RiverWarn.selectedAnnIdx === 0) {
          return "";
        } else {
          return " 最新の発表ではありません";
        }
      },
    },
    /** 戻るボタン表示有無 */
    isDispPrev: {
      get() {
        if (this.$store.state.RiverWarn.selectedAnnIdx === 0) {
          return false;
        } else {
          return true;
        }
      },
    },
    /** 次へボタン表示有無 */
    isDispNext: {
      get() {
        let maxIdx = this.$store.state.RiverWarn.selectedRwDetail.rw.length - 1;
        if (this.$store.state.RiverWarn.selectedAnnIdx === maxIdx) {
          return false;
        } else {
          return true;
        }
      },
    },
    /**
     * 選択中予警報種別
     */
    selectedWarnType: {
      get() {
        return this.$store.state.RiverWarn.selectedWarnType;
      },
    },
    /**
     * 選択中河川予警報詳細
     */
    selectedRwDetailRw: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rw[
          this.$store.state.RiverWarn.selectedAnnIdx
        ];
      },
    },
    /**
     * 選択中河川予警報マスタ
     */
    selectedRwDetailMt: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.mt;
      },
    },
    /**
     * 選択中河川予警報フラグ
     */
    selectedRwDetailRwFlg: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rwFlg;
      },
    },
    /**
     *  設定情報
     */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /**
     * 表示範囲の浸水想定区域データ
     */
    inundations: {
      get() {
        return {
          inundations: this.$store.state.inundation.inundations,
          selectedInundationParam: this.$store.state.inundation
            .selectedInundationParam,
        };
      },
    },
    /** 提供中の浸水想定一覧URL */
    inuListUrl: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls.inuListLink;
      },
    },
    dispIu: {
      get() {
        return this.isDisp;
      },
    },
    /** ズームレベル */
    zoom: {
      get() {
        return this.$store.state.map.zoom;
      },
    },
  },
  watch: {
    inundations(val) {
      this.selectedInundation = val.selectedInundationParam;
    },
    dispIu() {
      if (this.isDisp) {
        if (this.selectedRwDetailMt.inundation) {
          setTimeout(() => {
            this.$store.commit(
              "inundation/setSelectedInundationParam",
              this.selectedRwDetailMt.inundation
            );
            this.moveRw();
          }, 100);
        }
      } else {
        setTimeout(() => {
          this.$store.commit("inundation/setSelectedInundationParam", {
            inundationId: null,
            inundationNm: "非表示",
          });
        }, 100);
      }
    },
    selectedRwDetailRw() {
      this.isDisp = false;
    },
    /** ズームレベル */
    zoom() {
      if (
        this.isDisp &&
        this.zoom <= this.$store.state.map.mapConfig.zoomInundation
      ) {
        setTimeout(() => {
          this.$store.commit(
            "inundation/setSelectedInundationParam",
            this.selectedRwDetailMt.inundation
          );
        }, 100);
      }
    },
  },
  methods: {
    /**
     * PDF表示ボタンクリック
     */
    openPdf(cd, type, annNo, annTime, docType, id) {
      this.$log.debug(
        "[Riverwarn] openPdf(" +
          cd +
          "," +
          type +
          "," +
          annNo +
          "," +
          annTime +
          "," +
          docType +
          "," +
          id +
          ")"
      );
      // アクセスログ出力
      let name = "";
      if (type == "fldfr") name = "fdfore_pdf";
      if (type == "evstg") name = "wlinfo_pdf";
      if (type == "fldctl") name = "fdcntl_pdf";
      if (type == "damdsch") name = "damdischa_pdf";
      PageLog.log({
        page_log: name,
        flood_cd: cd,
        flood_no: annNo,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      var url =
        this.$store.state.app.config.riverWarnConfig.pdfPath +
        type +
        "/" +
        cd +
        "_" +
        Util.formatDate(annTime, "YYYYMMDDHHmm") +
        "_" +
        annNo +
        "_" +
        docType +
        "_" +
        id +
        ".pdf";
      this.$log.debug("url:" + url);
      window.open(url, "_blank");
    },
    /** 個別観測所画面へ遷移 */
    clickObs(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[RwInfo] clickObs(" + ofcCd + "," + itmkndCd + "," + obsCd + ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: Number(ofcCd),
        itmkndCd: Number(itmkndCd),
        obsCd: Number(obsCd),
      });
      // 画面遷移
      this.routerPushTm("/mb/tm");
    },
    /** 前の号を表示 */
    prevAnnIdx() {
      this.$log.debug("[RwInfo] prevAnnIdx");
      let idx = this.$store.state.RiverWarn.selectedAnnIdx;
      this.$store.commit("RiverWarn/setSelectedAnnIdx", idx - 1);
    },
    /** 次の号を表示 */
    nextAnnIdx() {
      this.$log.debug("[RwInfo] nextAnnIdx");
      let idx = this.$store.state.RiverWarn.selectedAnnIdx;
      this.$store.commit("RiverWarn/setSelectedAnnIdx", idx + 1);
    },
    /** 河川予警報選択時の地図移動 */
    moveRw() {
      // 関連市町村の緯度経度を取得
      let nLat = 0;
      let eLon = 0;
      let sLat = 999;
      let wLon = 999;
      this.selectedRwDetailMt.prefTwn.forEach((pref) => {
        pref.twn.forEach((twn) => {
          // 市町村情報を取得
          const target = this.$store.state.map.townLatLngList.find(
            (townInfo) => {
              return townInfo.twnCd == twn.twnCd;
            }
          );
          if (target) {
            // 最大と最小の緯度経度を設定
            if (target.maxLat > nLat) nLat = target.maxLat;
            if (target.maxLon > eLon) eLon = target.maxLon;
            if (target.minLat < sLat) sLat = target.minLat;
            if (target.minLon < wLon) wLon = target.minLon;
          }
        });
      });
      // 中心座標を設定
      let latLng = [];
      if (this.$store.state.RiverWarn.selectedWarnType == 30) {
        // ダム放流通知
        latLng = [this.selectedRwDetailMt.lat, this.selectedRwDetailMt.lon];
      } else {
        // 市町村座標の最大最小から中心を算出
        // 小数点計算の誤差を無くすため10*9倍にして計算する
        latLng = [
          (nLat * Math.pow(10, 9) + sLat * Math.pow(10, 9)) /
            2 /
            Math.pow(10, 9),
          (eLon * Math.pow(10, 9) + wLon * Math.pow(10, 9)) /
            2 /
            Math.pow(10, 9),
        ];
      }

      // 市町村座標を取得できていない場合は移動しない
      if (nLat != 0 && eLon != 0 && sLat != 999 && wLon != 999) {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.$store.state.map.mapConfig.zoomInundation,
          center: latLng,
        });
      } else {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.$store.state.map.mapConfig.zoomInundation,
          center: this.$store.state.map.center,
        });
      }

      setTimeout(() => {
        let lat = latLng[0];
        let lon = latLng[1];

        if (window.innerWidth < window.innerHeight) {
          // 画面が縦長の場合は上に1/4ずらす
          lat =
            lat -
            (this.$store.state.map.maxCoord[0] -
              this.$store.state.map.minCoord[0]) /
              4;
        } else {
          // 画面が横長の場合は左に1/4ずらす
          lon =
            lon +
            (this.$store.state.map.maxCoord[1] -
              this.$store.state.map.minCoord[1]) /
              4;
        }

        this.$store.commit("map/setFlyToInfo", {
          zoom: this.$store.state.map.mapConfig.zoomInundation,
          center: [lat, lon],
        });
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-info {
  font-size: 0.7rem;
  width: 100%;

  .rw-header {
    display: flex;
    align-items: center;
  }

  .rw-box-info {
    width: 100%;
    padding: 0px 0px 0px 0px;
  }
}

.rw-info-header {
  font-size: 0.8rem;
  font-weight: 600;
  border-bottom: solid lightgray 1px;
}

.rw-dam-header {
  font-size: 0.8rem;
  font-weight: 600;
  border-bottom: solid lightgray 1px;

  display: flex;
  flex-direction: row;
  align-items: center;

  .rw-box-dam-name {
    .rw-obs-name {
      letter-spacing: 0px;
      text-align: left;
      font-size: 0.8rem;
      font-weight: 500;
    }
    .rw-obs-name-kana {
      letter-spacing: 0px;
      text-align: left;
      font-size: 0.625rem;
      font-weight: 400;
    }
  }
}

.name_kana {
  letter-spacing: 0px;
  text-align: left;
  font-size: 0.6rem;
  font-weight: 400;
}
.name {
  letter-spacing: 0px;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 500;
}
.rw-state-header {
  display: flex;
  height: 20px;
  background-color: #dddddd;
  color: black;
  justify-content: center;
  align-items: center;
  .rw-state-header-state {
    color: orange;
    font-weight: bold;
  }
}
.rw-state-value {
  display: flex;
  // height: 30px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 0.8rem;
  .rw-state-row {
    display: flex;

    .rw-state-prev {
      display: flex;
      align-items: center;
      width: 40px;
    }

    .rw-state-next {
      display: flex;
      align-items: center;
      width: 40px;
    }

    .rw-state-text {
      flex: 1;
      text-align: center;
      word-wrap: break-word;
    }
  }
}
.rw-state-footer {
  display: flex;
  justify-self: flex-end;
  .rw-state-header-state {
    color: orange;
    font-weight: bold;
  }
}

.rw-tab-guide-tip {
  z-index: 3510;
}

.rw-span-warn {
  font-size: 10pt;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border-radius: 4px;
}

.rw-legend-img {
  width: 100%;
}
</style>
